<script lang="ts">
  import { downloadPDF, serverlessRoutes, translate, executeJob, errorTracker } from "lib";
  import { dialogData } from "stores";
  import { ButtonComponent, CheckboxComponent } from "ui";
  import { getPdfWithJwt } from "../../lib/requests";

  let data: any;
  let shouldIncludeDescriptions = false;

  const onClose = (): void => {
    $dialogData.type = "";
    $dialogData.data = {};
  };

  const onSubmit = async (): Promise<void> => {
    try {
      // Get the URL parameters from the data.url
      const {entityId, clientId} = data;

      onClose();

      // Use executeJob with POST request - this handles the job creation and completion automatically
      await executeJob<any>({
        endpoint: data.url, 
        payload: {
          entityId: parseInt(entityId || '0'),
          clientId: clientId ? parseInt(clientId) : undefined,
          shouldIncludeDescriptions,
        },
        successMessage: translate("PDF_GENERATED_SUCCESSFULLY"),
        errorMessage: translate("ERROR_GENERATING_PDF"),
        showSpinner: true, // Show job spinner instead of button loading
        timeout: 60000, // 60 seconds for PDF generation
        onProgress: (progress: number) => {
          console.log("PDF generation progress:", progress);
        },
        onSuccess: async (_, jobId) => {
          // Download the PDF using the jobId after job completion
          const blob = await getPdfWithJwt(`${serverlessRoutes.PDF}/${jobId}/download`);
          if (blob) {
            await downloadPDF(data.fileName, blob);
          }
        },
      });

    } catch (error) {
      errorTracker.captureError(error as Error | string, "error", {
        context: "pdf_export",
        action: "generate_pdf",
        entityId: data.entityId,
        clientId: data.clientId,
        fileName: data.fileName
      });
    }
  };

  export {data};
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="font-bold text-center">{translate("PDF_SETTINGS")}</div>

  <CheckboxComponent
    label={translate("EXPORT_WITH_DESCRIPTIONS")}
    bind:value={shouldIncludeDescriptions}
  />

  <div class="flex justify-center gap-4">
    <ButtonComponent isOutline on:click={onClose}>
      {translate("CANCEL")}
    </ButtonComponent>
    <ButtonComponent on:click={onSubmit}>
      {translate("EXPORT")}
    </ButtonComponent>
  </div>
</div>
